import React from "react";
import styled from "styled-components";
import { colors } from "./colors";

/** One pill of options, the selected one raised. */
export default function Segmented({ options, value, onChange, ariaLabel }) {
    return (
        <Row role="radiogroup" aria-label={ariaLabel}>
            {options.map((option) => (
                <Option key={option.value} type="button" role="radio" aria-checked={option.value === value}
                        $active={option.value === value} onClick={() => onChange(option.value)}>
                    {option.label}
                </Option>
            ))}
        </Row>
    );
}

const Row = styled.div`
    display: inline-flex;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${colors.line};
    background: ${colors.canvas};
    padding: 2px;
`;

const Option = styled.button`
    height: 28px;
    white-space: nowrap;
    border-radius: 6px;
    border: none;
    padding: 0 12px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: color 150ms, background 150ms, box-shadow 150ms;
    background: ${({ $active }) => ($active ? colors.surface : "transparent")};
    color: ${({ $active }) => ($active ? colors.ink : colors.muted)};
    box-shadow: ${({ $active }) => ($active ? `0 1px 2px rgba(15, 20, 25, 0.06), 0 0 0 1px ${colors.line}` : "none")};
    &:hover { color: ${colors.ink}; }
    &:focus-visible { outline: 2px solid ${colors.accent}66; outline-offset: 1px; }
`;
